<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Modul'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <!-- $func.exportCsv to export csv -->
                <ButtonComponent colors="#17A1FA" name="csv" @click.native="$func.exportCsv" />
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="moduls" :search="search">
                <template v-slot:item.no="{ index }">
                  {{ index + 1 }}.
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.id)"></ButtonComponent>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
        <b-modal @ok="onSubmit" ok-title="Simpan" no-enforce-focus ok-variant="primary" cancel-title="Batal"
          cancel-variant="danger" id="modal" :title="`${statusModal} Modul`">
          <b-form>
            <b-form-group label="Nama Modul :">
              <b-form-input id="input-1" v-model="request.name" type="text" required
                placeholder="Masukkan Nama Modul"></b-form-input>
            </b-form-group>
            <b-form-group label="Parent :">
              <Select2 v-model="request.parent_id" :options="options"
                :settings="{ settingOption: value, multiple: false, width: '100%' }" />
            </b-form-group>
            <b-form-group label="Url :">
              <b-form-input id="input-1" v-model="request.url" type="text" required
                placeholder="Masukkan Url"></b-form-input>
            </b-form-group>
            <b-form-group label="Urutan :">
              <b-form-input type="number" v-model="request.urutan" required placeholder="Masukkan Urutan"></b-form-input>
            </b-form-group>
            <b-form-group label="Status Tampil :">
              <Select2 v-model="request.status_tampil" :options="optionsStatus"
                :settings="{ multiple: false, width: '100%' }" />
            </b-form-group>

          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Select2 from 'v-select2-component';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";

export default {
  name: 'ModulPage',
  data() {
    return {
      options: [
        { id: null, text: '--Pilih Parent--' },
      ],
      optionsStatus: [
        { id: null, text: '--Pilih Status--' },
        { id: true, text: 'Tampil' },
        { id: false, text: 'Tidak Tampil' },
      ],
      statusModal: '',
      myValue: '',
      search: '',
      headers: [
        {
          text: "No",
          value: "no"
        },
        { text: "Nama Modul", value: "name", align: "center" },
        { text: "Parent", value: "parent_id" },
        { text: "Url", value: "url" },
        { text: "Status Tampil", value: "status_tampil" },
        { text: "Urutan", value: "urutan" },
        { text: "Aksi", value: "action" }
      ],
      moduls: [],
      request: {
        id: null,
        name: null,
        url: null,
        parent_id: null,
        urutan: null,
        status_tampil: null
      }
    };
  },
  components: {
    KTCodePreview,
    Select2,
    ButtonComponent,
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "User Management" },
      { title: "Modul" }
    ]);

    await this.getData()

    

    await this.getParentOptions()

    // filter property from object
    // const filterDataCsv = this.moduls.map(({ name, url }) => ({ name, url }));
    // set csv export name and data
    // this.$store.commit('updateCsvName', { name: 'Data Export Modul', data: filterDataCsv })
  },
  methods: {
    openModal(status, itemData = null) {
      this.statusModal = status

      // reset form
      this.request = {
        id: null,
        name: null,
        url: null,
        parent_id: null,
        urutan: null,
        status_tampil: null
      }
      if (status == 'Edit') {
        this.request.id = itemData.id
        this.request.name = itemData.name,
          this.request.url = itemData.url,
          this.request.parent_id = itemData.parent_id,
          this.request.urutan = itemData.urutan,
          this.request.status_tampil = itemData.status_tampil
      }
    },

    async getParentOptions() {
      try {
        await axios.get('master/get-parent')
          .then(response => {
            if (response.status == 200) {
              response.data.data.some((e, index) => {
                var object = { "id": e.id, "text": e.name }
                this.options.push(object);
                return index > e.length;
              });
              
            }
          })
      } catch (err) {
          this.$swal(`Gagal memuat data`);
      }
    },

    async getData() {
      try {
        const result = await axios.get(`master/menu`)

        this.moduls = result.data.data;
      } catch (err) {
          this.$swal(`Gagal memuat data Modul`);
      }
    },

    async onSubmit() {
      const form = this.request

      if (form.id === null) {
        // store
        this.store(form)
      } else {
        // update
        this.update(form)
      }
    },

    async store(form) {
      try {
        var formData = {
          name: form.name,
          url: form.url,
          parent_id: form.parent_id,
          urutan: form.urutan,
          status_tampil: form.status_tampil
        };

        const result = await axios.post(`master/menu`, formData)

        this.refreshData(result, 'Store')
      } catch (err) {
          this.$swal(`Gagal menambahkan data`);
      }
    },

    async update(form) {
      try {
        var formData = {
          name: form.name,
          url: form.url,
          parent_id: form.parent_id,
          urutan: form.urutan,
          status_tampil: form.status_tampil
        };

        const result = await axios.put(`master/menu/${form.id}`, formData)

        this.refreshData(result, 'Update')
      } catch (err) {
          this.$swal(`Gagal mengedit data`);
      }
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
        this.getParentOptions()
      } else {
          this.$swal(`Failed ${alert} Data`);
      }
    },

    async deleteData(id) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            const result = await axios.delete(`master/menu/${id}/`)
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          this.$swal(`Gagal menghapus data`);
      }
    }
  }
}
</script>